import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=71d3a85b&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71d3a85b')) {
      api.createRecord('71d3a85b', component.options)
    } else {
      api.reload('71d3a85b', component.options)
    }
    module.hot.accept("./contact.vue?vue&type=template&id=71d3a85b&", function () {
      api.rerender('71d3a85b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/user/contact.vue"
export default component.exports